// extracted by mini-css-extract-plugin
export default {"titleWrapper":"Receipt_titleWrapper__Ho97P","buttonWrapper":"Receipt_buttonWrapper__oQrVC"};